// Étape 14 — Pages publiques : avis client (/avis/{token}) et suivi annuel (/suivi/{token})
import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/public`;
const K = { navy: "#1B2A4A", gold: "#C8902C", cream: "#F7F3EA", mid: "#5d6475", border: "#e3dccb", green: "#2E7D4F", red: "#B3261E" };
const btn = { background: K.gold, color: "#fff", border: "none", borderRadius: 10, padding: "13px 18px", fontWeight: 700, fontSize: 15, cursor: "pointer", width: "100%", fontFamily: "inherit" };

const Shell = ({ children }) => (
  <div style={{ background: K.cream, minHeight: "100vh", fontFamily: "'Montserrat', sans-serif", color: K.navy }}>
    <div style={{ background: K.navy, color: K.cream, padding: "18px 20px", fontFamily: "'Playfair Display', serif", fontSize: 24, letterSpacing: 2 }}>AU<span style={{ color: K.gold }}>PRÉA</span></div>
    <div style={{ maxWidth: 560, margin: "30px auto", background: "#fff", border: `1px solid ${K.border}`, borderRadius: 14, padding: 24 }}>{children}</div>
  </div>
);

const Avis = ({ token }) => {
  const [d, setD] = useState(undefined);
  const [note, setNote] = useState(0);
  const [com, setCom] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => { axios.get(`${API}/avis/${token}`).then(r => setD(r.data)).catch(() => setD(null)); }, [token]);
  if (d === undefined) return <Shell>Chargement…</Shell>;
  if (d === null) return <Shell>Lien introuvable.</Shell>;
  if (d.deja || msg === "ok") return <Shell><div data-testid="avis-merci" style={{ color: K.green, fontWeight: 700 }}>Merci {d.prenom} pour votre avis !</div></Shell>;
  const envoyer = () => axios.post(`${API}/avis/${token}`, { note, commentaire: com }).then(() => setMsg("ok")).catch(e => setMsg(e?.response?.data?.detail || "Erreur"));
  return (
    <Shell>
      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }} data-testid="avis-page">Votre avis sur « {d.livrable} »</div>
      <div style={{ fontSize: 13, color: K.mid, marginBottom: 14 }}>Bonjour {d.prenom}, quelle note donneriez-vous à cet accompagnement ?</div>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {[1, 2, 3, 4, 5].map(n => <button key={n} onClick={() => setNote(n)} data-testid={`avis-note-${n}`} style={{ fontSize: 30, background: "none", border: "none", cursor: "pointer", color: n <= note ? K.gold : K.border }}>★</button>)}
      </div>
      <textarea value={com} onChange={(e) => setCom(e.target.value)} placeholder="Votre commentaire (facultatif)" data-testid="avis-commentaire"
        style={{ width: "100%", minHeight: 90, borderRadius: 10, border: `1px solid ${K.border}`, padding: 10, fontFamily: "inherit", marginBottom: 12, boxSizing: "border-box" }} />
      <button style={{ ...btn, opacity: note ? 1 : .5 }} disabled={!note} onClick={envoyer} data-testid="avis-envoyer">Envoyer mon avis</button>
      {msg && msg !== "ok" && <div style={{ color: K.red, fontSize: 13, marginTop: 8 }}>{msg}</div>}
    </Shell>
  );
};

const Suivi = ({ token }) => {
  const [d, setD] = useState(undefined);
  useEffect(() => { axios.get(`${API}/suivi-annuel/${token}`).then(r => setD(r.data)).catch(() => setD(null)); }, [token]);
  if (d === undefined) return <Shell>Chargement…</Shell>;
  if (d === null) return <Shell>Lien introuvable.</Shell>;
  if (d.interesse) return <Shell><div data-testid="suivi-merci" style={{ color: K.green, fontWeight: 700 }}>Merci {d.prenom} ! Votre consultant vous recontacte très prochainement avec votre proposition de suivi annuel.</div></Shell>;
  return (
    <Shell>
      <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }} data-testid="suivi-page">Votre suivi annuel AUPRÉA</div>
      <div style={{ fontSize: 13, color: K.mid, marginBottom: 16 }}>Bonjour {d.prenom}, souhaitez-vous que votre consultant vous propose la mise à jour annuelle de votre dossier ?</div>
      <button style={btn} onClick={() => axios.post(`${API}/suivi-annuel/${token}`).then(() => setD({ ...d, interesse: true }))} data-testid="suivi-interesse">Je suis intéressé(e)</button>
    </Shell>
  );
};

export default function PublicMission() {
  const [, type, token] = window.location.pathname.split("/");
  return type === "avis" ? <Avis token={token} /> : <Suivi token={token} />;
}
